import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalKeyTrap } from '../../hooks/useModalKeyTrap';
import './ConfirmModal.css';

interface ConfirmModalProps {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [focusedBtn, setFocusedBtn] = useState(1); // default: No (safer)

  useModalKeyTrap(useCallback(function (key, e) {
    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      e.preventDefault();
      setFocusedBtn(0);
    } else if (key === 'ArrowRight' || key === 'ArrowDown') {
      e.preventDefault();
      setFocusedBtn(1);
    } else if (key === 'Enter' || key === 'Space') {
      e.preventDefault();
      if (focusedBtn === 0) onConfirm();
      else onCancel();
    } else if (key === 'Back') {
      e.preventDefault();
      onCancel();
    }
  }, [focusedBtn, onConfirm, onCancel]));

  return (
    <div className="confirmmodal__overlay" onClick={onCancel}>
      <div className="confirmmodal__box" onClick={(e) => e.stopPropagation()}>
        <p className="confirmmodal__title">{title}</p>
        <p className="confirmmodal__desc">{description}</p>
        <div className="confirmmodal__actions">
          <button
            className={`confirmmodal__btn confirmmodal__btn--danger${focusedBtn === 0 ? ' confirmmodal__btn--focused' : ''}`}
            onClick={onConfirm}
          >
            {confirmLabel ?? t('common.yes')}
          </button>
          <button
            className={`confirmmodal__btn${focusedBtn === 1 ? ' confirmmodal__btn--focused' : ''}`}
            onClick={onCancel}
          >
            {cancelLabel ?? t('common.no')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
